import { type Testimonial } from '@common/types/testimonial.type';

import type { Observable } from 'rxjs';
import type { CollectionQueryItem, CollectionQueryStateStatuses } from '@common/adapters/collection-query';

import type { TestimonialsCollectionState } from './testimonials.reducer';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { mergeMap, of } from 'rxjs';
import TestimonialsActions from './testimonials.actions';
import * as TestimonialsSelectors from './testimonials.selectors';

@Injectable()
export class TestimonialsCollectionFacade {
    private readonly store = inject<Store<TestimonialsCollectionState>>(Store);

    public loadTestimonialsCollection(courseId: number): void {
        this.store.dispatch(TestimonialsActions.loadCollectionRequest({ courseId }));
    }

    public testimonials$(courseId: number): Observable<Testimonial[]> {
        if (!courseId) {
            return of([]);
        }

        return this.store.select(TestimonialsSelectors.selectTestimonials(courseId.toString())).pipe(
            mergeMap((testimonials: CollectionQueryItem<Testimonial[]>) => {
                if (!testimonials) {
                    this.loadTestimonialsCollection(courseId);
                    return of([]);
                }

                return of(testimonials.item || []);
            })
        );
    }

    public testimonialsStatuses$(courseId: number): Observable<CollectionQueryStateStatuses> {
        if (!courseId) {
            return of({} as any);
        }

        return this.store.select(TestimonialsSelectors.selectTestimonialsStatuses(courseId.toString()));
    }
}
